import { createI18n } from 'vue-i18n'
import en from '@/locales/en.json'
import zhTW from '@/locales/zh-TW.json'
import zhCN from '@/locales/zh-CN.json'

const messages = {
    en,
    'zh-TW': zhTW,
    'zh-CN': zhCN,
}
const savedLocale = localStorage.getItem('userLanguage')
const i18n = createI18n({
    legacy: false,
    locale: savedLocale || navigator.language || 'zh-TW',
    fallbackLocale: 'zh-TW',
    messages
})

export default i18n
